/**
 * Commitment mark (AC 3.x). A mark on a RANGE — not a node — so it survives edits and is
 * rendered by decoration. New text defaults to `provisional`; `/commit` transitions a range
 * to `committed`. INTERNAL: this file may reference prosemirror types; it is never re-exported
 * from `index.ts` in a way that leaks a PM type (only the plain {@link Commitment} shape is public).
 */

import type { MarkSpec } from 'prosemirror-model';
import type { CommitmentState } from '../../types';

export const COMMITMENT_MARK = 'commitment';

export const commitmentMark: MarkSpec = {
  attrs: {
    state: { default: 'provisional' as CommitmentState },
    by: { default: null },
    ts: { default: null },
  },
  // Inclusive so typing at the boundary of a provisional span stays provisional.
  inclusive: true,
  parseDOM: [
    {
      tag: 'span[data-commitment]',
      getAttrs: (dom) => {
        const el = dom as HTMLElement;
        return {
          state: (el.getAttribute('data-commitment') as CommitmentState) ?? 'provisional',
          by: el.getAttribute('data-commit-by'),
          ts: el.getAttribute('data-commit-ts'),
        };
      },
    },
  ],
  toDOM: (mark) => [
    'span',
    {
      'data-commitment': mark.attrs.state,
      'data-commit-by': mark.attrs.by ?? '',
      'data-commit-ts': mark.attrs.ts ?? '',
      class: mark.attrs.state === 'committed' ? 'docit-committed' : 'docit-provisional',
    },
    0,
  ],
};
